"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperWizard = void 0;
var react_1 = __importStar(require("react"));
var StepperStyles_1 = require("./StepperStyles");
var Stepper_1 = __importDefault(require("@material-ui/core/Stepper"));
var Step_1 = __importDefault(require("@material-ui/core/Step"));
var StepLabel_1 = __importDefault(require("@material-ui/core/StepLabel"));
var react_i18next_1 = require("react-i18next");
var FiberManualRecord_1 = __importDefault(require("@material-ui/icons/FiberManualRecord"));
var StepperWizardStepIcon = function (_a) {
    var completed = _a.completed, active = _a.active;
    return react_1.default.createElement(FiberManualRecord_1.default, { color: completed || active ? 'inherit' : 'disabled' });
};
exports.StepperWizard = react_1.default.memo(function (_a) {
    var labels = _a.labels, onStepClicked = _a.onStepClicked, step = _a.step, disabled = _a.disabled;
    var t = react_i18next_1.useTranslation('common').t;
    var classes = StepperStyles_1.useStepLabelStyles();
    var _b = react_1.useState(0), activeStep = _b[0], setActiveStep = _b[1];
    var clickedStep = function (step) {
        if (!disabled || !disabled[step]) {
            setActiveStep(step);
            if (onStepClicked) {
                onStepClicked(step);
            }
        }
    };
    react_1.useEffect(function () {
        if (step) {
            setActiveStep(step);
        }
    }, [step]);
    return (react_1.default.createElement("div", { style: StepperStyles_1.standardStepper },
        react_1.default.createElement("div", { style: StepperStyles_1.standardStepperInner },
            react_1.default.createElement(Stepper_1.default, { activeStep: activeStep, alternativeLabel: true }, labels.map(function (label, i) { return (react_1.default.createElement(Step_1.default, { key: label },
                react_1.default.createElement(StepLabel_1.default, { onClick: function () { return clickedStep(i); }, classes: classes, StepIconComponent: StepperWizardStepIcon, style: disabled && disabled[i] ? StepperStyles_1.standardStep : StepperStyles_1.selectableStep }, t(label)))); })))));
});
exports.StepperWizard.displayName = 'StepperWizard';
exports.default = exports.StepperWizard;
//# sourceMappingURL=StepperWizard.js.map